import { Text } from '@/shared/ui/primitives';
import { ChevronRight } from 'lucide-react';
import type { ButtonHTMLAttributes, FC, ReactNode } from 'react';

import styles from './InlineNavigationButton.module.css';

interface InlineNavigationButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  before: ReactNode;
  children: ReactNode;
  testId?: string;
}

export const InlineNavigationButton: FC<InlineNavigationButtonProps> = ({
  before,
  children,
  testId,
  ...props
}) => {
  return (
    <button {...props} type="button" className={styles.button} data-testid={testId}>
      {before}
      <Text variant="caption" weight="medium">
        {children}
      </Text>
      <ChevronRight size={14} aria-hidden="true" />
    </button>
  );
};
